import { FormProvider } from "react-hook-form";
import TailwindSideModal from "../../../components/commonModal/TailwindSideModal";
import TailwindBottomButtonView from "../../../components/mainBottomButtonView/TailwindBottomButtonView";
import CommonSplitContainer from "../../../components/ui/layout/CommonSplitContainer/CommonSplitContainer";
import LoadingOverlay from "../shared/components/LoadingOverlay";
import UserAvatarUpload from "../shared/components/UserAvatarUpload";
import UserFormFields from "../shared/components/UserFormFields";
import { useUserRegisterViewModel } from "./hooks/useUserRegisterViewModel";
import { UserRegisterModalProps } from "./types/userRegisterView.types";

/**
 * Tailwind rebuild of the legacy `UserRegisterModal`
 * (src/screens/user/userRegister/UserRegisterModal.tsx) on the same shell as
 * `CompanyRegisterModal`: `TailwindSideModal` + `CommonSplitContainer` +
 * `TailwindBottomButtonView`. State/submit logic lives in
 * `useUserRegisterViewModel`.
 */
const UserRegisterModal = ({
  visibleModal,
  roles,
  closeModal,
  onSuccess
}: UserRegisterModalProps) => {
  const vm = useUserRegisterViewModel({ visibleModal, closeModal, onSuccess });

  return (
    <>
      <TailwindSideModal
        open={visibleModal}
        onOpenChange={open => {
          if (!open) vm.onCancel();
        }}
        eyebrow="Users"
        title="Register user"
        titleClassName="tw-font-display"
        description="Add the user's contact details and choose the role that controls their access."
      >
        <FormProvider {...vm.methods}>
          <CommonSplitContainer
            currentHeight={0.86}
            overflowX="hidden"
            topChild={
              <div>
                <UserFormFields
                  control={vm.methods.control}
                  roles={roles}
                  rolePolicy={vm.rolePolicy}
                  avatarSlot={
                    <UserAvatarUpload
                      imageUrl={vm.pictureUrl}
                      initial="U"
                      onUpload={vm.onPictureSelect}
                      onRemove={() => vm.onPictureSelect(null)}
                    />
                  }
                />
              </div>
            }
            bottomChild={
              <TailwindBottomButtonView
                cancelButtonStatus
                saveButtonStatus
                saveTitle="Register user"
                buttonSize="lg"
                saveLoading={vm.isSaving}
                saveDisable={vm.isSaving}
                cancelButton={vm.onCancel}
                saveButton={vm.onSave}
              />
            }
          />
        </FormProvider>
      </TailwindSideModal>

      {vm.isSaving ? <LoadingOverlay /> : null}
    </>
  );
};

export default UserRegisterModal;
